import React from 'react';
import $ from 'jquery';
import getAuthonticatedJSON from '../../../common/utils/functions/getAuthonticatedJSON';
import { config } from '../../../config/config';
import jMoment from 'moment-jalaali';
import ServerSideDataTable from '../../../common/tables/components/ServerSideDataTable';
import Spinner from '../../../common/Spinner/Spinner';
import ProcessInfo from './ProcessInfo';
import TaskInfo from './TaskInfo';
import CaseHistory from './CaseHistory';
import { connect } from 'react-redux';
import * as Actions from '../NewInboxActions';
import _ from 'lodash';
import { smallBox } from '../../../common';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import './styles.css';
class Supervisor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			variableList: [],
		};
	}
	componentDidMount() {
		let self = this;
		this.getDataServer('to_revise');
		$(document).ready(function() {
			$(document).delegate('td.row-controller', 'dblclick', function() {
				let id = $(this).attr('id');

				self.getCaseOnClicked(id, function(clickedCase) {
					if (clickedCase)
						self.props.history.push('/outlook/detail/' + clickedCase.app_uid + '/' + clickedCase.del_index);
				});
			});

			$(document).delegate('.service-table-row', 'click', function() {
				let app_uid = $(this)
					.siblings('.service-id')
					.find('input')
					.attr('value');
				let CS = self.props.messages.filter(item => {
					return item.app_uid === app_uid;
				});
				if (_.head(CS).del_init_date != null) {
					$('#ServiceModal').modal('show');
					self.ManageService(app_uid);
					self.getHistory($(this).attr('id'));
					$('.nav-tabs li').removeClass('active');
					$('#tabs').tabs({ active: 0 });
				} else {
					smallBox({
						title: this.props.t('Error'),
						content: '<i>' + this.props.t('Case Not Opened') + '</i>',
						color: '#ff4136',
						iconSmall: 'fa fa-times fa-2x fadeInRight animated',
						timeout: 3200,
					});
				}
			});

			$(document).delegate('.remove-service', 'click', function() {
				let id = $(this)
					.siblings('.service-id')
					.find('div')
					.data('id');
				self.RemoveService(id);
			});
			$(document).delegate('.open-case', 'dblclick', function() {
				let id = $(this).attr('key');
			});

			$(document).delegate('.variable-modal', 'click', function() {
				let id = $(this).attr('id');

				self.showVariables(id);
			});

			$(document).delegate('.caseHistory', 'click', function() {
				let id = $(this).attr('id');
				self.getHistory($(this).attr('id'));
				$('#caseHistoryModal').modal('show');
			});
			$(document).delegate('.processInfo', 'click', function() {
				let id = $(this).attr('id');
				self.getProccessInformation($(this).attr('id'));
				$('#processInfoModal').modal('show');
			});
			$(document).delegate('.taskInfo', 'click', function() {
				let id = $(this).attr('id');
				self.getTaskInformation($(this).attr('id'));
				$('#taskInfoModal').modal('show');
			});

			$(document).delegate('.processMap', 'click', function() {
				let id = $(this).attr('id');

				self.getCaseOnClicked(id, function(clickedCase) {
					if (clickedCase)
						self.props.history.push(
							'/newInbox/processMap/' + clickedCase.app_uid + '/' + clickedCase.pro_uid
						);
				});
			});
		});
	}
	getCaseOnClicked(id, callback) {
		let item = this.props.messages.filter(x => {
			return parseInt(x.app_uid) === parseInt(id);
		});

		if (item.length > 0) callback(item[0]);
		else callback(null);

		// return item.length > 0 ? item[0] : null;
	}
	getHistory = app_uid => {
		this.setState({ loading: true });
		const URL = config.apiServer + 'cases/' + app_uid + '/tasks';

		getAuthonticatedJSON(URL)
			.then(res => {
				res = res.reverse();
				this.setState({
					caseHistory: res,
					loading: false,
				});
			})
			.catch(error => {
				this.handleError(error);
			});
	};

	// Level 2
	onShowProcessInformation = () => {
		if (this.state.processInfo != null) {
			if (this.state.proUID !== this.state.processInfo.PRO_UID) this.getProccessInformation();
		} else {
			this.getProccessInformation();
		}
	};

	getProccessInformation = pro_uid => {
		this.setState({ loading: true });
		const URL = config.apiServer + 'processinfo/processinformation?ProUid=' + pro_uid;
		getAuthonticatedJSON(URL)
			.then(res => {
				this.setState({
					processInfo: res,
					loading: false,
				});
			})
			.catch(error => {
				this.handleError(error);
			});
	};

	ManageService = app_uid => {
		let CS = this.props.messages.filter(item => {
			return item.app_uid === app_uid;
		});

		this.setState({
			proUID: _.head(CS).pro_uid,
			appUID: app_uid,
		});
	};

	getTaskInformation = id => {
		const URL =
			config.apiServer +
			'taskinfo/taskinformation?APP_UID=' +
			id.substring(0, 32) +
			'&TAS_UID=' +
			id.substring(32, 64) +
			'&DEL_INDEX=' +
			id.charAt(64);
		getAuthonticatedJSON(URL)
			.then(res => {
				this.setState({
					taskInfo: res,
					loading: false,
				});
			})
			.catch(error => {
				this.handleError(error);
			});
	};

	onShowTaskInfo = () => {
		if (this.state.taskInfo != null) {
			if (this.state.proUID !== this.state.taskInfo.PRO_UID) this.getTaskInformation();
		} else {
			this.getTaskInformation();
		}
	};
	getDataServer = (
		action,
		start,
		limit,
		filter,
		sort,
		dir,
		cat_uid,
		pro_uid,
		search,
		dateFrom,
		dateTo,
		newerThan,
		current
	) => {
		this.props.outlookPaginationServer(
			action,
			start,
			limit,
			filter,
			sort,
			dir,
			cat_uid,
			pro_uid,
			search,
			dateFrom,
			dateTo,
			newerThan,
			current
		);
	};

	getTableRow = item => {
		let filter = null;
		if (item.filter === '') {
			filter = '- -';
		} else {
			switch (item.filter) {
				case 'read':
					filter = 'خوانده شده';
					break;
				case 'unread':
					filter = 'خوانده نشده';
					break;
				default:
					filter = '- -';
			}
		}
		let action = null;
		if (item.action == null) {
			action = 'گردش کار';
		} else {
			switch (item.action) {
				case 'draft':
					action = 'پیش نویس';
					break;
				case 'unassigned':
					action = 'اختصاص نیافته';
					break;
				case 'sent':
					action = 'پیگیری';
					break;
				case 'todo':
				case 'inbox':
					action = 'ارجاع نشده';
					break;
				default:
					action = 'گردش کار';
			}
		}
		let t = item.tags;
		let tags = Object.values(t);
		let tagArr = [];

		tags.map(t =>
			tagArr.push(
				<div className="badge badge-pill" style={{ background: t.COLOR }}>
					{t.TITLE}
				</div>
			)
		);
		let init_date = jMoment(item.del_init_date).format('jYYYY/jMM/jDD');
		let init_time = jMoment(item.del_init_date).format('HH:mm:ss');

		let due_date = jMoment(item.del_task_due_date).format('jYYYY/jMM/jDD');
		let due_time = jMoment(item.del_task_due_date).format('HH:mm:ss');

		let color_due = null;
		if (item.due_date_status === 'red') {
			color_due = <div className="color_due" style={{ background: 'red' }}></div>;
		} else if (item.due_date_status === 'green') {
			color_due = <div className="color_due" style={{ background: 'green' }}></div>;
		} else if (item.due_date_status === 'yellow') {
			color_due = <div className="color_due" style={{ background: 'yellow' }}></div>;
		}
		let selected = null;
		if (item.default_variable)
			if (item.del_init_date != null) {
				if (item.default_variable.var_label) {
					selected = item.default_variable.var_label + ' : ' + item.default_variable.var_value;
				} else if (item.default_variable.var_name) {
					selected = item.default_variable.var_name + item.default_variable.var_value;
				} else selected = item.default_variable.var_uid;
			} else {
				if (item.default_variable.var_label) {
					selected = item.default_variable.var_label + item.default_variable.var_value;
				} else if (item.default_variable.var_name) {
					selected = item.default_variable.var_name + item.default_variable.var_value;
				} else {
					selected = item.default_variable.var_uid;
				}
			}
		else if (item.del_init_date != null) {
			selected = this.props.t('Dont Selected');
		} else {
			this.props.t('Dont Selected');
		}

		return (
			<tr role="row" className="odd open-case" key={item.app_uid} id={item.app_uid}>
				<td id={item.pro_uid} className="hidden clicked-item row-controller">
					<input type="text" value={item.usr_uid} />
				</td>
				{config.inboxCols['Activity'] === 0 ? null : (
					<td id={item.pro_uid} className="sorting_1 clicked-item  row-controller" tabIndex="0">
						<div className="row">
							{/* <div className="col col-md-2">{color_due}</div> */}
							{/* change title col-md-10 to 12  */}
							<div className="col col-md-12 pTitle">
								{item.app_pro_title}(<small className="text-muted">{item.app_tas_title}</small>)
							</div>
						</div>

						{tagArr.map(t => {
							return (
								<div className={t.props.className} style={{ background: t.props.style.background }}>
									{t.props.children}
								</div>
							);
						})}
					</td>
				)}
				{config.inboxCols['Status'] === 0 ? null : (
					<td id={item.pro_uid} className=" expand clicked-item row-controller">
						{action}
						<hr />
						{filter}
					</td>
				)}

				{config.inboxCols['ProcessNumber'] === 0 ? null : (
					<td id={item.pro_uid} className=" expand clicked-item row-controller">
						{item.app_number}
					</td>
				)}
				{config.inboxCols['ReciveDate'] === 0 ? null : (
					<td id={item.pro_uid} className="clicked-item row-controller">
						<span className="clicked-item  ">
							{init_date}
							<br /> {init_time}
						</span>
					</td>
				)}
				{config.inboxCols['DueDate'] === 0 ? null : (
					<td id={item.pro_uid} className="clicked-item row-controller">
						<span className="clicked-item  ">
							{due_date}
							<br /> {due_time}
						</span>
					</td>
				)}
				{config.inboxCols['PreviousUser'] === 0 ? null : (
					<td id={item.pro_uid} className="clicked-item  row-controller">
						{item.previous_user === '' ? '-' : item.previous_user}
					</td>
				)}

				{config.inboxCols['SelectedVariable'] === 0 ? null : (
					<td id={item.app_uid} className="clicked-item  row-controller variable-modal">
						{selected}
					</td>
				)}

				{config.inboxCols['ActionButton'] === 0 ? null : (
					<td>
						<td>
							<div className="dropdown">
								<button className="dropbtn">عملیات</button>
								<div className="dropdown-content">
									<a className="processMap" id={item.app_uid}>
										نقشه فرایند
									</a>
									<a className="caseHistory" id={item.app_uid}>
										تاریخچه
									</a>
									<a className="processInfo" id={item.pro_uid}>
										اطلاعات فرایند
									</a>
									<a className="taskInfo" id={item.app_uid + item.tas_uid + item.del_index}>
										اطلاعات وظیفه
									</a>
									<a className="tagModal" id={item.app_uid}>
										اختصاص برچسپ
									</a>
								</div>
							</div>
						</td>
					</td>
				)}
			</tr>
		);
	};

	render() {
		let dataRows = null;
		if (this.props.loading) {
			dataRows = <Spinner />;
		} else {
			if (this.props.messages && this.props.messages.length > 0) {
				var tmp = [];
				this.props.messages.map((user, index) => {
					tmp.push(this.getTableRow(user, index));
				});

				dataRows = (
					<ServerSideDataTable
						url={this.props.url}
						getDataList={(
							action,
							start,
							limit,
							filter,
							sort,
							dir,
							cat_uid,
							pro_uid,
							search,
							dateFrom,
							dateTo,
							newerThan,
							current
						) =>
							this.getDataServer(
								action,
								start,
								limit,
								filter,
								sort,
								dir,
								cat_uid,
								pro_uid,
								search,
								dateFrom,
								dateTo,
								newerThan,
								current
							)
						}
						action="to_revise"
						limit={this.props.pagination.limit}
						pagination={this.props.pagination}
						data={this.props.messages}
						filter={true}
					>
						<thead>
							<tr></tr>
							<tr role="row">
								{config.inboxCols['Activity'] === 0 ? null : (
									<th
										data-hide="phone"
										className="sorting_asc"
										tabindex="0"
										aria-controls="DataTables_Table_7"
										rowspan="1"
										colspan="1"
										aria-sort="ascending"
										width={config.inboxCols['Activity'] + '%'}
									>
										{this.props.t('Activity')}
									</th>
								)}
								{config.inboxCols['Status'] === 0 ? null : (
									<th
										data-className="expand"
										className="expand sorting"
										tabindex="0"
										aria-controls="DataTables_Table_7"
										rowspan="1"
										colspan="1"
										width={config.inboxCols['Status'] + '%'}
									>
										{this.props.t('وضعیت')}
									</th>
								)}
								{config.inboxCols['ProcessNumber'] === 0 ? null : (
									<th
										data-className="expand"
										className="expand sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['ProcessNumber'] + '%'}
									>
										{this.props.t('شماره فرایند')}
									</th>
								)}
								{config.inboxCols['ReciveDate'] === 0 ? null : (
									<th
										data-hide="phone"
										className="sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSspan="1"
										width={config.inboxCols['ReciveDate'] + '%'}
									>
										{this.props.t('RECEIVE DATE')}
									</th>
								)}
								{config.inboxCols['DueDate'] === 0 ? null : (
									<th
										data-hide="phone"
										className="sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['DueDate'] + '%'}
									>
										{this.props.t('مهلت اجرا')}
									</th>
								)}
								{/* <th
									className="sorting"
									tabindex="0"
									aria-controls="DataTables_Table_7"
									rowspan="1"
									colspan="1"
								>
									{this.props.t('ارسال')}
								</th> */}

								{config.inboxCols['PreviousUser'] === 0 ? null : (
									<th
										data-hide="phone,tablet"
										className="sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['PreviousUser'] + '%'}
									>
										{this.props.t('Previous User')}
									</th>
								)}

								{config.inboxCols['SelectedVariable'] === 0 ? null : (
									<th
										data-hide="phone,tablet"
										className="sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['SelectedVariable'] + '%'}
									>
										{this.props.t('Selected Variable')}
									</th>
								)}
								{config.inboxCols['ActionButton'] == 0 ? null : (
									<th
										data-hide="phone,tablet"
										className="sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['ActionButton'] + '%'}
									>
										عملیات
									</th>
								)}
							</tr>
						</thead>
						<tbody>{tmp}</tbody>
					</ServerSideDataTable>
				);

				// $('#searchBox').val(''+);
				setTimeout(() => {}, 500);
			} else {
				dataRows = (
					<div className="text-center" style={{ margin: 30 }}>
						<b>{this.props.t('Dont Exists Information For Show')}</b>
					</div>
				);
			}
		}

		let data = this.props.messages;

		var variables = (
			<table className="table table-bordered">
				<tbody>
					<tr>
						<td className="center"> {this.props.t('Not Value')}</td>
					</tr>
				</tbody>
			</table>
		);

		if (this.state.variableList.length > 0)
			variables = (
				<div>
					<table className="table table-bordered">
						<tbody>
							<tr>
								<td> {this.props.t('Key')}</td>
								<td> {this.props.t('Value')} </td>
							</tr>
							{this.state.variableList.map(variable => {
								if (!variable.var_label && !variable.var_name) {
									return (
										<tr>
											<td>{variable.var_uid}</td>
											<td>وارد نشده</td>
										</tr>
									);
								} else {
									return (
										<tr>
											<td>
												{variable.var_label === '' ? variable.var_name : variable.var_label}
											</td>
											<td>{variable.var_value}</td>
										</tr>
									);
								}
							})}
						</tbody>
					</table>
				</div>
			);

		let processInfo = <Spinner />;
		if (this.state.loading) processInfo = <Spinner />;
		else if (this.state.processInfo != null) processInfo = <ProcessInfo processInfo={this.state.processInfo} />;

		let taskInfo = null;
		if (this.state.loading) taskInfo = <Spinner />;
		else if (this.state.taskInfo != null) taskInfo = <TaskInfo taskInfo={this.state.taskInfo} />;

		let caseHistory = null;
		if (this.state.loading) caseHistory = <Spinner />;
		else if (this.state.caseHistory != null) caseHistory = <CaseHistory caseHistories={this.state.caseHistory} />;

		return (
			<div style={{ display: 'inline-block', width: '100%' }}>
				<div className="col-md-12 border-box">
					<div className="margin-top-10">
						<div className="table-wrap custom-scroll">{dataRows}</div>
					</div>
				</div>
				<div
					className="modal fade"
					id="caseHistoryModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby="ServiceModalLabel"
					aria-hidden="true"
				>
					<div className="modal-dialog" style={{ width: '65%' }}>
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
									&times;
								</button>
								<h4 className="modal-title" style={{ display: 'inline-block' }} id="ServiceModalLabel">
									{this.props.t('تاریخچه')}
								</h4>
							</div>
							<div className="">
								<form action="" className="smart-form" id="service-form" method="post">
									<div className="tabbable-panel">
										<div className="tabbable-line" id="tabs">
											<div className="tab-content add_service_modal_bx">
												<div className="tab-pane active" id="tab_default_4">
													{caseHistory}
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn_inbox btn_datatable" data-dismiss="modal">
									<i className="fa fa-window-close "></i>
									{this.props.t('Close')}
								</button>
							</div>
						</div>
					</div>
				</div>

				<div
					className="modal fade"
					id="processInfoModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby="ServiceModalLabel"
					aria-hidden="true"
				>
					<div className="modal-dialog" style={{ width: '65%' }}>
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
									&times;
								</button>
								<h4 className="modal-title" style={{ display: 'inline-block' }} id="ServiceModalLabel">
									{this.props.t('اطلاعات فرایند')}
								</h4>
							</div>
							<div className="">
								<form action="" className="smart-form" id="service-form" method="post">
									<div className="tabbable-panel">
										<div className="tabbable-line" id="tabs">
											<div className="tab-content add_service_modal_bx">
												<div className="tab-pane active" id="tab_default_4">
													{processInfo}
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn_inbox btn_datatable" data-dismiss="modal">
									<i className="fa fa-window-close "></i>
									{this.props.t('Close')}
								</button>
							</div>
						</div>
					</div>
				</div>

				<div
					className="modal fade"
					id="taskInfoModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby="ServiceModalLabel"
					aria-hidden="true"
				>
					<div className="modal-dialog" style={{ width: '65%' }}>
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
									&times;
								</button>
								<h4 className="modal-title" style={{ display: 'inline-block' }} id="ServiceModalLabel">
									{this.props.t('اطلاعات وظیفه')}
								</h4>
							</div>
							<div className="">
								<form action="" className="smart-form" id="service-form" method="post">
									<div className="tabbable-panel">
										<div className="tabbable-line" id="tabs">
											<div className="tab-content add_service_modal_bx">
												<div className="tab-pane active" id="tab_default_4">
													{taskInfo}
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn_inbox btn_datatable" data-dismiss="modal">
									<i className="fa fa-window-close "></i>
									{this.props.t('Close')}
								</button>
							</div>
						</div>
					</div>
				</div>

				<div
					className="modal fade"
					id="VariableModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby=""
					aria-hidden="true"
				>
					<div className="modal-dialog" style={{ width: '65%' }}>
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
									&times;
								</button>
								<h4 className="modal-title" style={{ display: 'inline-block' }} id="">
									{this.props.t('فیلد های منتخب')}
								</h4>
							</div>
							<div className="">
								<form action="" className="smart-form" id="service-form" method="post">
									<div className="tabbable-panel">
										<div className="tabbable-line" id="tabs">
											<div className="tab-content add_service_modal_bx">{variables}</div>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn_inbox btn_datatable" data-dismiss="modal">
									<i className="fa fa-window-close "></i>
									{this.props.t('Close')}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default compose(
	withTranslation(),
	connect(state => state.newInbox, Actions)
)(Supervisor);
